import { Injectable } from '@angular/core';
import { HttpServiceBase } from '../../common/services/http/httpServiceBase';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class LocationHttpService extends HttpServiceBase {

    constructor(protected http: HttpClient) {
        super('location');
    }

}
